module.exports = __webpack_public_path__ + "static/media/logo.a5ffc0b1.png";